module.exports = __webpack_public_path__ + "img/fach.318fcd9d.png";